module.exports = __webpack_public_path__ + "static/media/PB_Y_16.001e4dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_16.png
// module id = 245
// module chunks = 0